import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
         /**
         * 是否需要强制登录
         */
          forcedLogin: false,
          hasLogin: false,
          userName: "",
          userID: "",
          sessionID: "",

  },
  getters: {
  },
  mutations: {
    update(state,[key,value]){
			state[key]=value;
		},
  },
  actions: {
  },
  modules: {
  }
})
